
import './App.css';
import Cart from './components/Cart/Cart';

function App() {
  return (
    <div>
      <header>
        <Cart></Cart>
      </header>
    </div>
  );
}

export default App;
